<template>
  <div class="booking-customer">
    <div class="booking-customer-select">
      <el-select
        class="customer-select"
        filterable
        remote
        v-model="cuotomer"
        placeholder="请输入客户姓名/证件号/手机号"
        value-key="user_cardno"
        :remote-method="remoteMethod"
        :loading="cuotomerLoading"
        :disabled="readonly"
        @change="selectChange"
        style="width: 400px; max-width: 100%"
        ref="select"
        @hook:mounted="cancalReadOnly"
        @visible-change="cancalReadOnly"
      >
        <el-option
          class="customer-select-option"
          v-for="option in cuotomerList"
          :key="option.empi"
          :label="option.name"
          :value="option.empi"
          :value-key="option.empi"
        >
          <div class="customer-select-item">
            <div>
              <span>{{ desensitizeString(option.name) }}</span>
              <span>{{ option.user_cardno }}</span>
            </div>
            <div>
              <span>{{ option.idNum_encry }}</span>
              <span>{{ option.user_mobile_encry }}</span>
            </div>
            <!-- <template v-if="option.scrm_account_id">
              <div>
                <span>渠道</span>
              </div>
              <div>
                <span>{{ option.scrm_account_name }}</span>
                <span>{{ option.scrm_important_level }}</span>
              </div>
              <div>
                <span>{{ option.scrm_user_name }}</span>
              </div>
            </template> -->
          </div>
          <!-- <span>{{ option.user_sex_displayname }}</span> -->
        </el-option>
      </el-select>
      <i
        class="el-icon-circle-plus-outline"
        @click="goPage('BookingAdd')"
      ></i>
    </div>
    <div class="booking-division" />

    <div
      class="booking-customer-current"
      @click="goEdit"
      v-if="currentCuotomer"
    >
      <div class="booking-customer-current-left">
        <div>
          <span>
            {{ desensitizeString(currentCuotomer.name) }}
          </span>
          <span>
            {{ hisEnum.lst_sexMap[currentCuotomer.user_sex] }}
          </span>
          <span>
            {{ currentCuotomer.user_mobile_encry }}
          </span>
          <span> {{ currentCuotomer.level }} </span>
        </div>
        <div>
          <span> 储值金金额：{{ currentCuotomer.accountBalance }} </span>
          <span> 历史消费金额：{{ currentCuotomer.history_consumed }} </span>
        </div>
        <div class="booking-customer-label">
          <span
            class="booking-label"
            v-show="currentCuotomer.book_family_member_patient_id"
          >
            {{ currentCuotomer.book_family_member_name }}的{{
              allEnum.ApplyFamilyRelation[currentCuotomer.book_family_relation]
            }}
          </span>
          <span
            class="booking-label"
            v-show="currentCuotomer.scrm_account_name"
          >
            {{ currentCuotomer.scrm_account_name }}
          </span>
          <span
            class="booking-label"
            v-for="label in currentCuotomer.label_list"
            :key="label.label_code"
          >
            {{ label.label_name }}
          </span>
        </div>
        <div>
          <span> 服务管家：{{ currentCuotomer.service_butler }} </span>
          <span> 家庭医生：{{ currentCuotomer.family_doctor }} </span>
        </div>
      </div>
      <div class="booking-customer-current-right">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
// import hisService from "@/apis/his/index";

import enums from "@/views/booking/mixins/enums";
import { mapGetters } from "vuex";
import { Dialog } from "vant";

export default {
  name: "customer",
  mixins: [enums],
  computed: {
    ...mapGetters(["bookingUserInfo"]),
  },
  watch: {
    bookingUserInfo: {
      handler(newVal) {
        console.log(newVal);
        if (newVal.customer_empi) {
          newVal.empi = newVal.customer_empi;
          newVal.name = newVal.customer_name;
          newVal.user_mobile_encry = newVal.customer_mobile2;
          newVal.user_sex = newVal.customer_sex;
          newVal.user_cardno = newVal.customer_bingan;
          newVal.level = newVal.customer_level;
          newVal.history_consumed = newVal.history_amount;
          newVal.accountBalance = newVal.stored_amount;
          this.cuotomerList = [newVal];
          this.cuotomer = newVal.empi;
          this.selectChange(newVal.empi);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cuotomer: undefined,
      currentCuotomer: undefined,
      cuotomerLoading: false,
      cuotomerList: [],
    };
  },
  created() {
    this.initCustomerInfo();
  },
  methods: {
    async initCustomerInfo() {
      const query = this.$route.query;

      if (query.mobile) {
        await this.remoteMethod(query.mobile);
        if (this.cuotomerList.length) {
          this.cuotomer = this.cuotomerList[0].empi;
          this.selectChange(this.cuotomer);
        }
      }
    },
    init() {
      this.cuotomerList = [];
      this.currentCuotomer = undefined;
      this.cuotomer = undefined;
    },
    desensitizeString(str) {
      // 字符串长度小于等于1，不做脱敏处理直接返回
      if (str.length <= 1) {
        return str;
      }
      // 如果字符串长度是2，仅隐藏后一位
      else if (str.length === 2) {
        return str.substring(0, 1) + "*";
      }
      // 字符串长度大于2时，隐藏除首尾之外的中间字符
      else {
        const start = str.substring(0, 1);
        const end = str.substring(str.length - 1, str.length);
        const middle = "*".repeat(str.length - 2);
        return start + middle + end;
      }
    },

    hisCustomerSearch() {},
    remoteMethod(value) {
      if (!value) return;
      const params = {
        in_text: value,
        pageNo: 1,
        pageSize: 9999,
      };

      this.cuotomerLoading = true;
      return bookingService.hisCustomerSearch(params).then((res) => {
        this.cuotomerLoading = false;
        res.forEach((item) => {
          item.user_mobile_encry =
            item.user_mobile && this.desensitization(item.user_mobile, 3, -4);
          item.idNum_encry =
            item.idNum && this.desensitization(item.idNum, 3, -4);
        });
        this.cuotomerList = res;
      });
    },
    selectChange(value) {
      const { cuotomerList } = this;
      cuotomerList.some((item) => {
        if (item.empi === value) {
          if (!item.scrm_account_id || !item.customer_region_code) {
            Dialog.confirm({
              title: "提示",
              message: "该用户的渠道或所属地区为空，需要先完善信息",
              confirmButtonText: "去编辑",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.$router.push({
                  name: "BookingAdd",
                  query: {
                    type: "edit",
                    id: item.empi,
                  },
                });
              })
              .catch(() => {
                this.cuotomer = undefined;
                this.currentCuotomer = undefined;
              });
            return true;
          }
          this.$emit("change", item);
          this.currentCuotomer = item;
          return true;
        }
        return false;
      });
    },
    goPage(name) {
      if (this.readonly) return;
      this.$router.push({
        name,
      });
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    goEdit() {
      if (this.readonly) return;
      this.$router.push({
        name: "BookingAdd",
        query: {
          type: "edit",
          id: this.currentCuotomer.empi,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-customer-select {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
  i {
    font-size: 20px;
    margin-left: 20px;
  }
  .el-input__inner {
    border: none;
  }
}
.booking-customer-current {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  .booking-customer-current-left {
    flex: 1;
    font-size: 15px;
    & > div {
      display: flex;
      margin-top: 20px;
      &:nth-child(1) {
        margin-top: 0;
        flex-wrap: wrap;
      }
    }
    .booking-customer-label {
      flex-wrap: wrap;
      margin-top: 0;
      font-size: 13px;
      span {
        margin-top: 20px;
      }
    }
  }
  span {
    margin-right: 20px;
    word-break: break-all;
  }
}

.customer-select-option {
  // display: flex;
  justify-content: space-between;
  overflow: auto;
  height: unset;
  line-height: 20px;
  padding: 10px 20px;
  span {
    white-space: pre-line;
    word-break: break-all;
    &:nth-child(1) {
      margin-right: 10px;
    }
    &:nth-child(2) {
      flex-shrink: 0;
    }
  }
}

.customer-select-item {
  display: flex;
  flex-direction: column;
  & > div {
    display: flex;
    justify-content: space-between;
  }
}
</style>
